import { Translations } from './index';

export const es419: Translations = {
  app: {
    name: 'Buscador de Eventos',
    tagline: 'Descubre Eventos en Todo el Mundo',
    description: 'Descubre eventos de organizaciones, universidades y ciudades con búsqueda impulsada por IA',
  },

  header: {
    searchPlaceholder: 'Buscar eventos, temas o ubicaciones...',
    searchingEvents: 'Buscando eventos...',
    noSuggestionsFound: 'No se encontraron sugerencias',
    searchButton: 'Buscar',
    categoriesView: 'Categorías',
    mapView: 'Eventos cerca de mí',
    calendarView: 'Vista de Calendario',
    feedback: 'Comentarios',
    createGroup: 'Crear grupos de eventos',
    myEvents: 'Mis eventos',
    menu: 'Menú',
    howItWorks: 'Cómo funciona',
    latestUpdates: 'Últimas actualizaciones',
    upcomingShort: 'próximos',
  },

  suggestions: {
    locations: 'Ubicaciones',
    entities: 'Empresas tecnológicas, corporaciones, universidades y organizaciones',
    events: 'Eventos',
    location: 'Ubicación',
    relevance: 'Relevancia',
  },

  homepage: {
    heroTitle: 'Descubre Eventos Increíbles',
    heroSubtitle: 'Encuentra y explora eventos que coincidan con tus intereses con nuestra búsqueda impulsada por IA',
    popularEvents: 'Eventos Populares',
    topCities: 'Ciudades Principales',
    viewAllEvents: 'Ver Todos los Eventos',
    exploreEvents: 'Explorar Eventos',
    discoverEvents: 'Descubrir Eventos',
    findEventsNearby: 'Encontrar Eventos Cercanos',
    liveStats: {
      ariaLabel: 'Actividad actual de Event Finder',
      upcoming: 'Próximos',
      inPerson: 'Presenciales',
      virtual: 'Virtuales',
      hybrid: 'Híbridos',
      organizations: 'Organizaciones',
      partners: 'empresas tecnológicas',
      companies: 'corporaciones',
      webSources: 'Fuentes web',
      cities: 'ciudades',
      countries: 'países',
      continents: 'continentes',
      addedPastWeek: 'agregados en 7 días',
      updated: 'Actualizado',
      fresh: 'Datos recientes',
      loading: 'Cargando actividad actual',
    },
  },

  events: {
    upcoming: 'Próximos',
    past: 'Pasados',
    virtual: 'Virtual',
    inPerson: 'Presencial',
    free: 'Gratis',
    paid: 'De pago',
    eventDetails: 'Detalles del evento',
    venue: 'Lugar',
    date: 'Fecha',
    time: 'Hora',
    location: 'Ubicación',
    organizer: 'Organizador',
    category: 'Categoría',
    register: 'Registrarse',
    moreInfo: 'Más información',
    noEventsFound: 'No se encontraron eventos',
    loadingEvents: 'Cargando eventos...',
    relatedTo: 'Relacionado con',
    duration: 'Duración',
    eventSource: 'Fuente del evento',
    universityHosted: 'Organizado por una universidad',
    universityFallbackName: 'una universidad',
    universityAttendanceNotice: 'Este evento es organizado por {university}. Los eventos universitarios pueden tener restricciones de asistencia o elegibilidad. Revisa la página del evento o los detalles de registro antes de asistir.',
    universityCampusPrecision: 'nivel del campus (universidad anfitriona)',
  },

  browse: {
    title: 'Explorar Eventos',
    searchResultsTitle: 'Resultados de búsqueda para "{query}"',
    searchResultsDescription: 'Descubre eventos relacionados con "{query}" usando búsqueda potenciada por IA',
    noResultsTitle: 'No se encontraron eventos',
    noResultsDescription: 'Intenta ajustar tus criterios de búsqueda o filtros',
    showingResults: 'Mostrando {count} de {total} eventos',
    filtersApplied: 'Filtros aplicados',
  },

  map: {
    title: 'Eventos cerca de mí',
    subtitle: 'Explora eventos alrededor del mundo',
    eventsNearby: 'Eventos Cercanos',
    showingEvents: 'Mostrando eventos',
    zoomToArea: 'Acercar al área',
    currentLocation: 'Ubicación Actual',
    enableLocation: 'Activar Ubicación',
    failedToLoadEvents: 'Error al cargar eventos. Por favor intenta de nuevo más tarde.',
    failedToGetLocation: 'Error al obtener tu ubicación. Por favor activa los servicios de ubicación.',
  },

  calendar: {
    title: 'Calendario de Eventos',
    subtitle: 'Ver eventos por fecha',
    monthView: 'Vista Mensual',
    weekView: 'Vista Semanal',
    dayView: 'Vista Diaria',
    today: 'Hoy',
    nextMonth: 'Próximo Mes',
    previousMonth: 'Mes Anterior',
    eventsToday: 'Eventos de Hoy',
    noEventsThisDay: 'No hay eventos programados para este día',
  },

  filters: {
    filterBy: 'Filtrar Por',
    dateRange: 'Rango de Fechas',
    location: 'Ubicación',
    category: 'Categoría',
    price: 'Precio',
    eventType: 'Tipo de Evento',
    clearFilters: 'Limpiar Filtros',
    applyFilters: 'Aplicar Filtros',
    startDate: 'Fecha de Inicio',
    endDate: 'Fecha de Fin',
    anyPrice: 'Cualquier Precio',
    freeOnly: 'Solo Gratis',
    paidOnly: 'Solo de Pago',
    anyType: 'Cualquier Tipo',
    virtualOnly: 'Solo Virtual',
    inPersonOnly: 'Solo Presencial',
  },

  actions: {
    search: 'Buscar',
    clear: 'Limpiar',
    cancel: 'Cancelar',
    save: 'Guardar',
    edit: 'Editar',
    delete: 'Eliminar',
    share: 'Compartir',
    export: 'Exportar',
    print: 'Imprimir',
    refresh: 'Actualizar',
    back: 'Atrás',
    next: 'Siguiente',
    previous: 'Anterior',
    close: 'Cerrar',
    submit: 'Enviar',
  },

  time: {
    today: 'Hoy',
    tomorrow: 'Mañana',
    yesterday: 'Ayer',
    thisWeek: 'Esta Semana',
    nextWeek: 'Próxima Semana',
    thisMonth: 'Este Mes',
    nextMonth: 'Próximo Mes',
    morning: 'Mañana',
    afternoon: 'Tarde',
    evening: 'Noche',
    night: 'Madrugada',
    days: {
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
      sunday: 'Domingo',
    },
    months: {
      january: 'Enero',
      february: 'Febrero',
      march: 'Marzo',
      april: 'Abril',
      may: 'Mayo',
      june: 'Junio',
      july: 'Julio',
      august: 'Agosto',
      september: 'Septiembre',
      october: 'Octubre',
      november: 'Noviembre',
      december: 'Diciembre',
    },
  },

  errors: {
    general: 'Ocurrió un error. Por favor intenta de nuevo.',
    networkError: 'Error de red. Por favor verifica tu conexión.',
    notFound: 'No se encontró el elemento solicitado.',
    unauthorized: 'No estás autorizado para acceder a este recurso.',
    serverError: 'Error del servidor. Por favor intenta de nuevo más tarde.',
    invalidInput: 'Entrada inválida. Por favor verifica tus datos.',
    tryAgainLater: 'Por favor intenta de nuevo más tarde.',
    pageNotFound: 'Página no encontrada.',
    locationError: 'No se puede acceder a tu ubicación.',
  },

  success: {
    eventSaved: '¡Evento guardado exitosamente!',
    filtersSaved: '¡Filtros guardados exitosamente!',
    settingsUpdated: '¡Configuración actualizada exitosamente!',
    feedbackSubmitted: '¡Comentarios enviados exitosamente!',
  },

  loading: {
    general: 'Cargando...',
    events: 'Cargando eventos...',
    suggestions: 'Cargando sugerencias...',
    map: 'Cargando mapa...',
    calendar: 'Cargando calendario...',
    searching: 'Buscando...',
  },

  categories: {
    technology: 'Tecnología',
    business: 'Negocios',
    education: 'Educación',
    healthcare: 'Salud',
    entertainment: 'Entretenimiento',
    sports: 'Deportes',
    arts: 'Artes',
    science: 'Ciencia',
    community: 'Comunidad',
    networking: 'Networking',
    conference: 'Conferencia',
    workshop: 'Taller',
    seminar: 'Seminario',
    meetup: 'Encuentro',
    webinar: 'Webinar',
  },

  footer: {
    companyName: 'Event Finder',
    companyDescription: 'Descubre y conéctate con eventos increíbles en todo el mundo. Desde encuentros locales hasta conferencias internacionales, te ayudamos a encontrar experiencias que importan para ti.',
    contactEmail: 'hola@eventfinder.site',
    contactPhone: '+1 (555) 123-EVENT',
    contactAddress: 'Ciudad de México, MX',
    
    // CTA Section
    ctaTitle: '¿Listo para Descubrir Eventos Increíbles?',
    ctaDescription: 'Usa el botón de comentarios en el encabezado para compartir tus pensamientos y ayudarnos a mejorar tu experiencia de descubrimiento de eventos.',
    ctaButton: 'Dar Comentarios',
    
    // Quick Links Section
    quickLinksTitle: 'Enlaces Rápidos',
    aboutUs: 'Acerca de Nosotros',
    ourServices: 'Nuestros Servicios',
    blogResources: 'Blog y Recursos',
    latestUpdates: 'Últimas actualizaciones',
    careers: 'Carreras',
    helpCenter: 'Centro de Ayuda',
    contact: 'Contacto',
    
    // Platform Section
    platformTitle: 'Plataforma',
    browseEvents: 'Explorar Eventos',
    eventCalendar: 'Calendario de Eventos',
    advancedSearch: 'Búsqueda Avanzada',
    apiDocumentation: 'Documentación API',
    mobileApp: 'Aplicación Móvil',
    siteMap: 'Mapa del Sitio',
    siteStatistics: 'Estadísticas del Sitio',
    
    // Trust & Safety Section
    trustSafetyTitle: 'Confianza y Seguridad',
    securityCenter: 'Centro de Seguridad',
    accessibility: 'Accesibilidad',
    communityGuidelines: 'Directrices de la Comunidad',
    trustSafety: 'Confianza y Seguridad',
    reportIssue: 'Reportar Problema',
    
    // Trust Badges
    sslSecured: 'SSL Seguro',
    iso27001: 'ISO 27001',
    gdprCompliant: 'Cumple GDPR',
    
    // Legal Links
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
    cookiePolicy: 'Política de Cookies',
    disclaimer: 'Descargo de Responsabilidad',
    
    // Copyright
    copyright: '©',
    allRightsReserved: 'Todos los derechos reservados',
  },

  howItWorks: {
    title: 'Cómo funciona Event Finder',
    subtitle: 'Descubrimiento de eventos potenciado por IA a gran escala',
    heroTitle: 'Event Finder: Descubrimiento de eventos potenciado por IA a gran escala',
    heroSubtitle: 'Descubre cómo usamos tecnología IA de vanguardia para encontrar eventos en miles de sitios web en todo el mundo',
    
    challengeTitle: 'El desafío: Encontrar agujas en el pajar digital',
    challengeDescription: 'Imagina tratar de monitorear manualmente miles de sitios web de eventos en todo el mundo para descubrir próximos eventos, conferencias, talleres y sesiones de capacitación. Cada sitio web tiene diferentes diseños, horarios de actualización y formatos. Algunos anuncian eventos con meses de anticipación, otros solo semanas. Perderse un solo evento importante podría significar perder valiosas oportunidades de negocio.',
    
    solutionTitle: 'La solución potenciada por IA: Descubrimiento web inteligente',
    solutionDescription: 'Event Finder transforma esta tarea manual imposible en un sistema de descubrimiento automatizado e inteligente que funciona 24/7.',
    
    aiVisionTitle: '🧠 Sistema de visión IA dual',
    aiVisionDescription: 'El sistema emplea dos enfoques de IA complementarios para asegurar que ningún evento pase desapercibido:',
    
    primaryMethodTitle: '1. Inteligencia Markdown',
    primaryMethodSubtitle: 'Método principal',
    primaryMethodDescription: 'Nuestro enfoque principal convierte sitios web complejos en datos estructurados y limpios para análisis de IA.',
    primaryMethodFeatures: {
      webScraping: 'Web Scraping avanzado: Convierte sitios web HTML complejos en texto markdown estructurado y limpio',
      gptProcessing: 'Procesamiento GPT-4o-mini: Usa LLMs recientes de OpenAI para entender y extraer información de eventos del texto',
      contextUnderstanding: 'Comprensión del contexto: La IA no solo busca palabras clave—entiende contexto, fechas, ubicaciones y tipos de eventos'
    },
    
    fallbackMethodTitle: '2. Análisis IA visual',
    fallbackMethodSubtitle: 'Método de respaldo',
    fallbackMethodDescription: 'Cuando el análisis de texto no es suficiente, nuestra IA visual interviene para interpretar el contenido web como lo haría un humano.',
    fallbackMethodFeatures: {
      screenshotTechnology: 'Tecnología de capturas de pantalla: Captura instantáneas visuales de sitios web usando automatización Chrome',
      computerVision: 'Visión por computadora: Usa GPT-4o con capacidades de visión para "ver" e interpretar contenido web como lo haría un humano',
      layoutIntelligence: 'Inteligencia de diseño: Reconoce listas de eventos, calendarios y anuncios sin importar el diseño del sitio web'
    },
    
    smartMatchingTitle: '🎯 Coincidencia inteligente de eventos y deduplicación',
    smartMatchingDescription: 'El verdadero poder viene de prevenir la sobrecarga de información:',
    
    vectorSimilarityTitle: 'Coincidencia de similitud vectorial',
    vectorSimilarityFeatures: {
      semanticUnderstanding: 'Comprensión semántica: Usa embeddings avanzados para entender que "Taller de Azure" y "Capacitación de Microsoft Cloud" podrían ser el mismo evento',
      intelligentDeduplication: 'Deduplicación inteligente: Previene que el mismo evento sea registrado múltiples veces en diferentes sitios web de eventos',
      confidenceScoring: 'Puntuación de confianza: Cada coincidencia obtiene una puntuación de confianza, asegurando precisión'
    },
    
    fuzzyLogicTitle: 'Procesamiento de lógica difusa',
    fuzzyLogicFeatures: {
      dateIntelligence: 'Inteligencia de fechas: Entiende que "Próximo martes" y "15 de marzo" podrían referirse a la misma fecha',
      locationMatching: 'Coincidencia de ubicación: Reconoce que "Seattle, WA" y "Seattle, Washington" son el mismo lugar',
      titleVariations: 'Variaciones de título: Captura eventos incluso cuando las empresas usan nombres ligeramente diferentes'
    },
    
    processingPipelineTitle: '🔄 Pipeline de procesamiento inteligente',
    processingPipelineDescription: 'El sistema opera a través de una arquitectura sofisticada basada en colas que procesa miles de sitios web eficientemente:',
    processingPipelineFeatures: {
      qualityControl: 'Control de calidad automatizado',
      freshnessFiltering: 'Filtrado de frescura: Elimina automáticamente eventos de más de 2 semanas para mantener datos actuales',
      dataValidation: 'Validación de datos: Asegura que la información de eventos esté completa y correctamente formateada',
      errorRecovery: 'Recuperación de errores: Si un método falla, el sistema automáticamente prueba enfoques alternativos'
    },
    
    cloudArchitectureTitle: '🚀 Arquitectura en la nube escalable',
    cloudArchitectureDescription: 'Construido en la infraestructura de grado empresarial de Azure:',
    cloudArchitectureFeatures: {
      parallelProcessing: 'Procesamiento paralelo: Puede analizar cientos de sitios web simultáneamente',
      autoScaling: 'Auto-escalado: Ajusta automáticamente recursos basado en la carga de trabajo',
      faultTolerance: 'Tolerancia a fallos: Continúa procesando incluso si sitios web individuales están caídos',
      globalReach: 'Alcance global: Procesa sitios web de todo el mundo en múltiples zonas horarias'
    },
    
    resultsTitle: 'Los resultados increíbles',
    resultsDescription: 'Nuestro sistema potenciado por IA entrega rendimiento excepcional y valor de negocio.',
    
    businessValueTitle: '💡 Valor de negocio',
    businessValueForBD: 'Para desarrollo de negocios: Nunca pierdas oportunidades de asociación, descubre eventos conjuntos y posibilidades de colaboración, obtén inteligencia competitiva y ve tendencias de la industria meses por adelantado.',
    businessValueForMarketing: 'Para equipos de marketing: Encuentra oportunidades de contenido, patrocinios de eventos, oportunidades de hablar, insights de audiencia y eventos de alto valor para participación.',
    businessValueForSales: 'Para equipos de ventas: Genera leads de asistentes a eventos, construye relaciones en reuniones de la industria y obtén inteligencia de mercado sobre necesidades de clientes.',
    
    technologyStackTitle: 'El stack tecnológico: IA de primera clase',
    azureOpenAITitle: '🤖 Integración Azure OpenAI: GPT-4o y GPT-4o-mini para comprensión de contenido, modelos de embeddings de texto para similitud semántica y capacidades de visión para procesamiento de contenido visual.',
    azureSearchTitle: '🔍 Azure AI Search: Búsqueda vectorial para encontrar eventos similares, búsqueda semántica para comprensión de intención e indexación en tiempo real de nuevos eventos.',
    analyticsTitle: '📊 Analytics comprehensivos: Application Insights para monitoreo, dashboards personalizados para rastreo de tendencias y métricas de calidad para medir precisión.',
    
    realWorldImpactTitle: 'Impacto en el mundo real',
    realWorldImpactDescription: 'Imagina descubrir que tres de tus socios clave están organizando conferencias de IA en el mismo mes, dándote oportunidades para coordinar marketing, planear eventos complementarios, evitar conflictos y crear asociaciones. O encontrar tendencias tecnológicas emergentes semanas antes de que se vuelvan mainstream.',
    
    ctaTitle: '¿Listo para desbloquear la inteligencia oculta en miles de sitios web?',
    ctaDescription: 'Los eventos del mañana se están planeando hoy—asegúrate de ser el primero en conocerlos.',
    ctaButton: 'Explorar eventos ahora'
  },

  regional: {
    currency: 'USD',
    dateFormat: 'DD/MM/YYYY',
    timeFormat: '12-hour',
    numberFormat: '1.234,56',
    phoneFormat: '+52 (555) 123-4567',
    addressFormat: 'Calle, Ciudad, Estado, Código Postal',
  },
};
